import { render, staticRenderFns } from "./UpdatePatientProfileModal.vue?vue&type=template&id=11e4fea6&"
import script from "./UpdatePatientProfileModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePatientProfileModal.vue?vue&type=style&index=0&id=11e4fea6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports